export default __webpack_public_path__ + "static/media/S19pro.03c009f7.png";